// Get Active Files
export const GET_ACTIVE_FILES_REQUEST = 'GET_ACTIVE_FILES_REQUEST';
export const GET_ACTIVE_FILES_SUCCESS = 'GET_ACTIVE_FILES_SUCCESS';
export const GET_ACTIVE_FILES_FAILURE = 'GET_ACTIVE_FILES_FAILURE';

// Get Covering Files
export const GET_COVERING_FILES_REQUEST = 'GET_COVERING_FILES_REQUEST';
export const GET_COVERING_FILES_SUCCESS = 'GET_COVERING_FILES_SUCCESS';
export const GET_COVERING_FILES_FAILURE = 'GET_COVERING_FILES_FAILURE';

// Get Closed Files
export const GET_CLOSED_FILES_REQUEST = 'GET_CLOSED_FILES_REQUEST';
export const GET_CLOSED_FILES_SUCCESS = 'GET_CLOSED_FILES_SUCCESS';
export const GET_CLOSED_FILES_FAILURE = 'GET_CLOSED_FILES_FAILURE';

// Get Current Coverage
export const GET_CURRENT_COVERAGE_REQUEST = 'GET_CURRENT_COVERAGE_REQUEST';
export const GET_CURRENT_COVERAGE_SUCCESS = 'GET_CURRENT_COVERAGE_SUCCESS';
export const GET_CURRENT_COVERAGE_FAILURE = 'GET_CURRENT_COVERAGE_FAILURE';

// Assign Coverage
export const ASSIGN_COVERAGE_REQUEST = 'ASSIGN_COVERAGE_REQUEST';
export const ASSIGN_COVERAGE_SUCCESS = 'ASSIGN_COVERAGE_SUCCESS';
export const ASSIGN_COVERAGE_FAILURE = 'ASSIGN_COVERAGE_FAILURE';

// Update Coverage
export const UPDATE_COVERAGE_REQUEST = 'UPDATE_COVERAGE_REQUEST';
export const UPDATE_COVERAGE_SUCCESS = 'UPDATE_COVERAGE_SUCCESS';
export const UPDATE_COVERAGE_FAILURE = 'UPDATE_COVERAGE_FAILURE';

// Cancel Coverage
export const CANCEL_COVERAGE_REQUEST = 'CANCEL_COVERAGE_REQUEST';
export const CANCEL_COVERAGE_SUCCESS = 'CANCEL_COVERAGE_SUCCESS';
export const CANCEL_COVERAGE_FAILURE = 'CANCEL_COVERAGE_FAILURE';

// Get Internal Users
export const GET_INTERNAL_USERS_REQUEST = 'GET_INTERNAL_USERS_REQUEST';
export const GET_INTERNAL_USERS_SUCCESS = 'GET_INTERNAL_USERS_SUCCESS';
export const GET_INTERNAL_USERS_FAILURE = 'GET_INTERNAL_USERS_FAILURE';

// Get Notifications
export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';

// Dismiss Notification
export const DISMISS_NOTIFICATION_REQUEST = 'DISMISS_NOTIFICATION_REQUEST';
export const DISMISS_NOTIFICATION_SUCCESS = 'DISMISS_NOTIFICATION_SUCCESS';
export const DISMISS_NOTIFICATION_FAILURE = 'DISMISS_NOTIFICATION_FAILURE';

// UI State
export const SET_COVERAGE_MODAL_OPEN = 'SET_COVERAGE_MODAL_OPEN';
export const SET_COVERAGE_MODAL_CLOSED = 'SET_COVERAGE_MODAL_CLOSED';
export const SET_SELECTED_FILES = 'SET_SELECTED_FILES';
export const CLEAR_SELECTED_FILES = 'CLEAR_SELECTED_FILES';
